import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { getAdminMe, postAdminLogin, postAdminLogout } from "@/api/admin";
import { queryKeys } from "@/api/queryKeys";

export function useAdminMe() {
  return useQuery({
    queryKey: queryKeys.admin.me(),
    queryFn: getAdminMe,
    retry: false,
    staleTime: 60_000,
  });
}

export function useAdminLogin() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ username, password }: { username: string; password: string }) =>
      postAdminLogin(username, password),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: queryKeys.admin.me() });
    },
  });
}

export function useAdminLogout() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: postAdminLogout,
    onSuccess: async () => {
      queryClient.setQueryData(queryKeys.admin.me(), undefined);
      await queryClient.invalidateQueries({ queryKey: queryKeys.admin.all });
    },
  });
}
